import Button from '@doordash/component-button'
import { Inset, Text } from '@doordash/design-language'
import { get } from 'lodash'
import * as React from 'react'
import { connect } from 'react-redux'
import { Application } from 'src/utilities/application/application'
import * as actions from '../../../actions'
import {
  ANDROID_CLOSE_DEEPLINK,
  DD_READY_FIRST_DASH_TS,
  IOS_CLOSE_DEEPLINK,
} from '../../../constants'
import * as events from '../../../events'
import { GetSales } from '../../../models/types'
import * as DA from '../../../typeModules/events'
import SimpleStore from '../../../utilities/SimpleStore'
import { detectWebviewOs } from '../../../utilities/userAgent'
import { OsTypes } from '../../../webview/types'
import { Specialist } from '../../atoms/images/in-app-education/specialist'
import FAQ from '../../molecules/faq'
import TalkToSpecialistForm from '../../molecules/talk-to-specialist'

import s from './strings'
import { WaitWrapper } from './styles'

const os = detectWebviewOs()

type Props = {
  application?: Application
  experiments?: any
  getSalesData: GetSales
  getSales?: (uniqueLink: string, phone: string) => Promise<any>
  closeInAppEducation?: (any) => Promise<any>
  trackWebviewClosed?: () => Promise<any>
  trackGetSalesContactForm?: (data: DA.GetSales) => Promise<void>
}

export const Contact: React.SFC<Props> = ({
  application,
  experiments,
  closeInAppEducation,
  trackWebviewClosed,
  trackGetSalesContactForm,
  getSales,
  getSalesData,
}) => {
  const [phone, setPhone] = React.useState(get(application, 'phoneNumber'))
  const uniqueLink = get(application, 'uniqueLink')

  const onSubmit = async () => {
    try {
      await getSales(uniqueLink, phone)
      trackGetSalesContactForm({ phone })
    } catch (error) {
      trackGetSalesContactForm({
        phone,
        error: {
          code: get(error, 'response.status'),
          msg: get(error, 'message'),
        },
      })
    }
  }

  return (
    <React.Fragment>
      {getSalesData.wait ? (
        <WaitWrapper>
          <div>
            <Specialist />
          </div>
          <div>
            <Text>{s.talkToSpecialist.confirmation(getSalesData.phone)}</Text>
            <br />
            <br />
            <Text size={Text.Sizes.S14}>
              {s.talkToSpecialist.estimatedWait(getSalesData.wait)}
            </Text>
          </div>
        </WaitWrapper>
      ) : (
        <TalkToSpecialistForm
          phone={phone}
          onPhoneChange={setPhone}
          onSubmit={onSubmit}
        />
      )}
      <FAQ />
      <Inset isSquished={true} size={Inset.Sizes.Small}>
        <Button
          type={Button.Types.PrimaryPill}
          size={Button.Sizes.Large}
          tag="a"
          href={
            os === OsTypes.iOS ? IOS_CLOSE_DEEPLINK : ANDROID_CLOSE_DEEPLINK
          }
          onClick={() => {
            trackWebviewClosed()
            if (experiments.in_app_education_localstorage) {
              SimpleStore.set(DD_READY_FIRST_DASH_TS, Date.now())
            } else {
              closeInAppEducation(uniqueLink)
            }
          }}
        >
          {s.readyForFirstDashButton()}
        </Button>
      </Inset>
    </React.Fragment>
  )
}

const mapStateToProps = state => ({
  application: state.application,
  experiments: state.experiments,
  getSalesData: state.getSales,
})

const mapDispatchToProps = {
  trackWebviewClosed: events.trackWebviewClosed,
  trackGetSalesContactForm: events.trackGetSalesContactForm,
  closeInAppEducation: actions.closeInAppEducation,
  getSales: actions.getSales,
}

export default connect(mapStateToProps, mapDispatchToProps)(Contact)
